// extracted by mini-css-extract-plugin
module.exports = {"rating-container":"rating-display_component_rating-container__3l_IT","stars":"rating-display_component_stars__Sdonz"};